import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/local_scenery_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  appid_cont: {
    model_name: 'LocalScenery',
    column_type: 'string',
    column_name: 'appid',
  },
  name_cont: {
    model_name: 'LocalScenery',
    column_type: 'string',
    column_name: 'name',
  },
  path_cont: {
    model_name: 'LocalScenery',
    column_type: 'string',
    column_name: 'path',
  },
  jump_page_type_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'LocalScenery',
      options: ['local', 'mini_program'],
    },
    model_name: 'LocalScenery',
    column_name: 'jumpPageType',
  },
  env_version_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'LocalScenery',
      options: ['release', 'develop', 'trial'],
    },
    model_name: 'LocalScenery',
    column_name: 'envVersion',
  },
}
export const formColumnsConfig = {
  'self': {
    'appid': { required: false, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'path': { required: false, disabledUpdate: false },
    'env_version': { required: false, disabledUpdate: false },
    'content': { required: false, disabledUpdate: false },
    'cover': { required: true, disabledUpdate: false },
    'jump_page_type': { required: true, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
    'station_ids': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('LocalScenery', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('LocalScenery', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
